import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper, Grid } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions } from '../../components/Dialog/Dialog';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import { addNewParty, getPartyList, emptyPartyList } from "../../../store/actions/tripActionCreator";
import { getAllVendors, addNewVendor, singleVendorDetails, editVendor } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces, formatPhoneNumber } from "../../../utils/utils";
import * as logger from "../../../logger";
import { trackDwebEvent } from '../../analytics';
import {
  getVendorLedgerData,
} from "../../../store/actions/homeActionCreator";
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import AddIcon from '@material-ui/icons/Add';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { TickShield } from '../../../components/icons';
import { defaultPageNo,defaultPageSize } from '../../../paginationVariables';
const styles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  marginV2: {
    marginTop: 16
  },
  title: {
    color: '#9ea0a5',
    fontSize: 12
  },
  formHelperText: {
    color: '#9ea0a5',
    fontSize: 11,
    marginTop: 4,
  },
  marginV1: {
    marginTop: 6,
    width: '100%'
  },
  textV1: {
    marginTop: 6,
    width: '100%',
    "& .MuiOutlinedInput-input": {
      textTransform: 'capitalize',
    },
  },
  divFlex: {
    display: 'flex',
    alignItems: 'center',
    color: '#0033cc',
    marginTop: 20,
    letterSpacing: '0.02em',
    fontWeight: 300,
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  textV2: {
    marginLeft: 4,
    cursor: 'pointer'
  },
  divAlign: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },
  addIcon: {
    marginTop: -2,
    fontSize: 15,
    cursor: 'pointer'
  },
  disableCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#efeff2',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3e3f42',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em'
  },
  saveCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#0033cc',
    fontSize: 14,
    fontWeight: 300,
    color: 'white',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    '&:hover': {
      backgroundColor: '#0033cc',
    }
  },
  brV1: {
    borderRadius: 8
  }
}))
const AddSupplier = (props) => {
  const { children, user, defaultId, defaultName, defaultNumber, dispatchGetVendorLedgerAction, dispatchEditSingleVendor, dispatchGetSingleVendorDetails, dispatchEmptyPartyList, dispatchAddNewVendor, dispatchGetAllVendors, classes, open, onClose, onSave, ...other } = props;
  let submit;
  const [dialogopen, setDialogOpen] = React.useState(open);
  const [supplierNameValue, setSupplierNameValue] = useState(defaultName ? defaultName : "");
  const [dataFlag, setDataFlag] = useState(false);
  const [mobileNumberFlag, setMobileNumberFlag] = useState(defaultNumber ? true : false);


  const inlineStyles = styles();

  const initialValues = {
    name: supplierNameValue ? supplierNameValue : defaultName,
    mobile: defaultNumber ? defaultNumber.replace(/(\d{5})(\d{5})/, "$1-$2") : '',
  }


  const { register, handleSubmit, control, errors } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: defaultName ? defaultName : '',
      mobile: defaultNumber ? defaultNumber : '',
    },
  });

  const vendorLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    pageNo: defaultPageNo,
    pageSize: defaultPageSize,
  };

  const handlePartySave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
  };

  const onSubmit = data => {

    let supplierNameArray = data.name.split(" ");
    let supplierNameCapitalize = [];

    if (supplierNameArray && supplierNameArray.length > 0) {
      supplierNameArray.forEach((value) => {
        if (value) {
          supplierNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
        }
      })
    }

    if (defaultId) {
      var vendorData = {
        vendorName: supplierNameCapitalize && supplierNameCapitalize.length > 0 ? (supplierNameCapitalize.join(" ")).trim() : "",
        vendorNumber: data && data.mobile ? data.mobile.replace("-", "") : null
      }
      dispatchEditSingleVendor(defaultId,
        vendorData,
        (data) => {
          if (data && data.status && data.status.code && data.status.code == 200) {
            logger.log("Add Supplier Component Dweb", "Edit Single Vendor Successfull");
            sendSucces("Supplier Updated Successfully!");
            onSave(data.response);
            handleClose();
          }
        },
        () => {
          logger.log("Add Supplier Component Dweb", "Edit Single Vendor Failed");
        }
      );
    }
    else {
      dispatchAddNewVendor(
        {
          vendorName: supplierNameCapitalize && supplierNameCapitalize.length > 0 ? (supplierNameCapitalize.join(" ")).trim() : "",
          vendorNumber: data && data.mobile ? data.mobile.replace("-", "") : null
        },
        (addResponse) => {
          if (addResponse && addResponse.status && addResponse.status.code && addResponse.status.code == 200) {
            //dispatchEmptyPartyList();
            dispatchGetAllVendors(() => {
              trackDwebEvent("Dweb Supplier Create", {
                "supplier_id": addResponse.id,
                "supplier_name": addResponse.vendorName,
              });
              setTimeout(() => {
                handleClose();
                dispatchGetVendorLedgerAction(vendorLedgerRequestData)
                sendSucces("Supplier Created Successfuly!")
                onSave(true, addResponse.response);
              }, 300)
            },
              () => {

              })
          }
        },
        () => {
        }
      );
    }
  };

  // const handleSupplierName = (name) => {

  //   if (/^\s+$/.test(name)) {
  //     setSupplierNameValue('');
  //   } else {
  //     setSupplierNameValue(name);
  //   }

  // }

  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div>
              <div className={inlineStyles.title}>Supplier Name</div>
              <TextField
                placeholder="Enter Supplier Name"
                name="name"
                variant="outlined"
                size="small"
                // onChange={(e) => handleSupplierName(e.target.value)}
                fieldProps={{
                  parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                }}
                className={inlineStyles.textV1}
              />
            </div>
          </>
        ),
      },
      {
        size: 12,
        visible: !mobileNumberFlag,
        field: (
          <>
            <div className={inlineStyles.divFlex}>
              <AddIcon className={inlineStyles.addIcon} onClick={() => setMobileNumberFlag(true)} />
              <div className={inlineStyles.textV2} onClick={() => setMobileNumberFlag(true)}>
                Add Mobile Number
              </div>
            </div>
          </>
        )
      },
      {
        size: 12,
        visible: mobileNumberFlag,
        field: (
          <>
            <div className={inlineStyles.marginV2}>
              <div className={inlineStyles.title}>Mobile Number</div>
              <TextField
                placeholder="Enter Mobile Number"
                name="mobile"
                variant="outlined"
                size="small"
                fieldProps={{
                  parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">+91</InputAdornment>
                }}
                className={inlineStyles.marginV1}
              />
              <div className={inlineStyles.formHelperText}>Optional</div>
            </div>
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div className={inlineStyles.divAlign}>
              <TickShield />
              <div>
                100% Safe & Secure
              </div>
              <FiberManualRecordIcon className={inlineStyles.titleBullet}></FiberManualRecordIcon>
              <div>
                256-bit Encryption
              </div>
            </div>
          </>
        )
      }
    ]
  }

  const validate = values => {

    const errors = {}

    // let supplierName = values.name ? /^[A-Za-z]+$/.test(values.name.replace(/\s+/g, '')) : "";
    let number = values.mobile ? /^[5-9]{1}[0-9]{9}$/.test(values.mobile.replace("-", "")) : "";

    if (values && !values.name) {
      errors.name = "Please enter valid name."
    }
    if (values.mobile && !number) {
      errors.mobile = "Please enter valid mobile number."
    }

    if (values && values.name) {
      setDataFlag(true);
    } else {
      setDataFlag(false);
    }

    return errors;

  }

  return (
    <div>
      <Dialog fullWidth={true}
        maxWidth='xs'
        onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}
        classes={{ paperScrollPaper: inlineStyles.brV1 }}
      >
        <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
          {!defaultId &&
            <span>Add Supplier Details</span>
          }
          {defaultId &&
            <span>Edit Supplier Details</span>
          }
        </DialogTitle>
        <DialogContent dividers>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            id="myForm"
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit
              return (
                <form onSubmit={handleSubmit} noValidate id="myForm">
                  <Grid container alignItems="flex-start">
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                </form>
              )
            }}
          />

        </DialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button className={!dataFlag ? inlineStyles.disableCta : inlineStyles.saveCta} type="submit" variant="contained"
            // onClick={() => {
            //   document.getElementById('myForm')
            //     .dispatchEvent(new Event('submit', { cancelable: true }))
            // }}
            onClick={event => {
              submit(event)
            }}
            disabled={!dataFlag}
          >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddNewVendor: (data, onSuccess, onFailure) => dispatch(addNewVendor(data, onSuccess, onFailure)),
  dispatchGetAllVendors: (onSuccess, onFailure) => dispatch(getAllVendors(null, onSuccess, onFailure)),
  dispatchGetSingleVendorDetails: (id, onSuccess, onFailure) => dispatch(singleVendorDetails(id, onSuccess, onFailure)),
  dispatchEditSingleVendor: (id, data, onSuccess, onFailure) => dispatch(editVendor(id, data, onSuccess, onFailure)),
  dispatchEmptyPartyList: () => dispatch(emptyPartyList()),
  dispatchGetVendorLedgerAction: (requestData) =>
    dispatch(
      getVendorLedgerData(
        requestData,
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Success");
        },
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Failure");
        }
      )
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSupplier);